import { defaultFill } from '../utils/constants';
var muiCalendar16 = {
    paths: [
        {
            path: 'M4,2 L4,0.997030139 C4,0.446385598 4.44386482,0 5,0 C5.55228475,0 6,0.453036308 6,0.997030139 L6,2 L8,2 L8,0.997030139 C8,0.446385598 8.44386482,0 9,0 C9.55228475,0 10,0.453036308 10,0.997030139 L10,2 L13.2223361,2 C13.651828,2 14,2.34606934 14,2.77766394 L14,15.2223361 C14,15.651828 13.6539307,16 13.2223361,16 L0.777663941,16 C0.348172006,16 0,15.6539307 0,15.2223361 L0,2.77766394 C0,2.34817201 0.346069336,2 0.777663941,2 L4,2 Z M4,4 L2,4 L2,6 L4,6 L4,4 L4,4 Z M6,4 L6,6 L8,6 L8,4 L6,4 L6,4 Z M10,4 L10,6 L12,6 L12,4 L10,4 Z M12,8 L2,8 L2,14 L12,14 L12,8 L12,8 Z',
            fill: defaultFill,
        },
    ],
    title: 'Calendar',
    width: 14,
    height: 16,
};
var muiCalendar24 = {
    paths: [
        {
            path: 'M17,0 C17.5522847,0 18,0.443716645 18,0.999807492 L18,1 L20.7779567,1 C21.4528726,1 22,1.519104 22,2.16649591 L22,20.8335041 C22,21.477742 21.4561768,22 20.7779567,22 L1.22204334,22 C0.547127438,22 0,21.480896 0,20.8335041 L0,2.16649591 C0,1.52225801 0.543823242,1 1.22204334,1 L4,1 L4,0.999807492 C4,0.487070378 4.38272018,0.0644804239 4.88266744,0.00672643618 L5,0 C5.55228475,0 6,0.443716645 6,0.999807492 L6,1 L16,1 L16,0.999807492 C16,0.487070378 16.3827202,0.0644804239 16.8826674,0.00672643618 L17,0 Z M20,8 L2,8 L2,20 L20,20 L20,8 Z M6,16 L6,18 L4,18 L4,16 L6,16 Z M10,16 L10,18 L8,18 L8,16 L10,16 Z M14,16 L14,18 L12,18 L12,16 L14,16 Z M18,16 L18,18 L16,18 L16,16 L18,16 Z M6,13 L6,15 L4,15 L4,13 L6,13 Z M10,13 L10,15 L8,15 L8,13 L10,13 Z M14,13 L14,15 L12,15 L12,13 L14,13 Z M18,13 L18,15 L16,15 L16,13 L18,13 Z M6,10 L6,12 L4,12 L4,10 L6,10 Z M10,10 L10,12 L8,12 L8,10 L10,10 Z M14,10 L14,12 L12,12 L12,10 L14,10 Z M18,10 L18,12 L16,12 L16,10 L18,10 Z M4,3 L2,3 L2,6 L20,6 L20,3 L18,3 L18,4.00019251 C18,4.51292962 17.6172798,4.93551958 17.1173326,4.99327356 L17,5 C16.4477153,5 16,4.55628335 16,4.00019251 L16,3 L6,3 L6,4.00019251 C6,4.51292962 5.61727982,4.93551958 5.11733256,4.99327356 L5,5 C4.44771525,5 4,4.55628335 4,4.00019251 L4,3 Z',
            fill: defaultFill,
        },
    ],
    title: 'Calendar',
    width: 22,
    height: 22,
};
var muiCalendar = {
    base: muiCalendar16,
    smIcon: muiCalendar16,
    lgIcon: muiCalendar24,
};
export { muiCalendar };
//# sourceMappingURL=calendar.js.map